import { OrderStatusObject } from '../order-status-object.model';
import { OrderDetailsGeneralItemObject } from './order-details-general-item-object.model';
import { CharacteristicObject } from '../../characteristics/characteristic/characteristic-object.model';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { isNullOrUndefined } from 'util';
import { OrderTypeObject } from '../order-type-object.model';
import { CharacteristicsObject } from '../../characteristics/characteristics.model';
import { OrderDetailsProductObject } from '../order-details-product/order-details-product-object.model';
import { OrderDetailsServicesObject } from '../order-details-services/order-details-services-object.model';
import { OrderDetailsProcessObject } from '../order-details-process/order-details-process-object.model';

export class OrderDetailsGeneralObject {
  private items: Array<OrderDetailsGeneralItemObject>;
  private isCancellable: boolean;

  constructor(private orderId: string, private status: OrderStatusObject, private domain: string, private type: OrderTypeObject,
    private productOrder: string, private statusField: string, private crmId: string, private priority: number,
    private urgent: boolean, private creationDate: Date, private estimatedStartDate: Date, private characteristics: CharacteristicsObject,
    private cancellationReason: string, private product: OrderDetailsProductObject,
    private service: OrderDetailsServicesObject, isCancellable: boolean,
    private processes: Array<OrderDetailsProcessObject>) {
    this.isCancellable = isCancellable != null ? isCancellable : true;
  }

  public static create(): OrderDetailsGeneralObject {
    return new OrderDetailsGeneralObject(StringUtils.NOT_AVALIABLE, OrderStatusObject.create(),
      StringUtils.NOT_AVALIABLE, null, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
      StringUtils.NOT_AVALIABLE, 0, false, new Date(), new Date(), CharacteristicsObject.create(),
      StringUtils.NOT_AVALIABLE, OrderDetailsProductObject.create(), OrderDetailsServicesObject.create(), false,
      new Array<OrderDetailsProcessObject>());
  }


  public getOrderId(): string {
    return this.orderId;
  }

  public getStatus(): OrderStatusObject {
    return this.status;
  }

  public setStatus(status: OrderStatusObject): void {
    this.status = status;
  }

  public getDomain(): string {
    return this.domain;
  }

  public getType(): OrderTypeObject {
    return this.type;
  }

  public getProductOrder(): string {
    return this.productOrder;
  }

  public getStatusField(): string {
    return this.statusField;
  }

  public getCrmId(): string {
    return this.crmId;
  }
  public getPriority(): number {
    return this.priority;
  }

  public setPriority(priority: number): void {
    this.priority = priority;
  }

  public isUrgent(): boolean {
    return this.urgent;
  }

  public getCreationDate(): Date {
    return this.creationDate;
  }

  public getEstimatedStartDate(): Date {
    return this.estimatedStartDate;
  }

  public setEstimatedStartDate(date: Date): void {
    this.estimatedStartDate = date;
  }

  public getItems(): Array<OrderDetailsGeneralItemObject> {
    return this.items;
  }

  public getInputCharacteristics(): Array<CharacteristicObject> {
    return this.characteristics.inputCharacteristics;
  }

  public getOutputCharacteristics(): Array<CharacteristicObject> {
    return this.characteristics.outputCharacteristics;
  }

  public getCharacteristics(): CharacteristicsObject {
    return this.characteristics;
  }

  public getCancellationReason(): string {
    return this.cancellationReason;
  }

  public hasCharacteristics(): boolean {
    return !isNullOrUndefined(this.numberOfCharacteristics) && this.numberOfCharacteristics() > 0;
  }

  public numberOfCharacteristics(): number {
    return this.characteristics.inputCharacteristics.length + this.characteristics.outputCharacteristics.length;
  }

  public getProduct(): OrderDetailsProductObject {
    return this.product;
  }

  public getService(): OrderDetailsServicesObject {
    return this.service;
  }

  public getIsCancellable(): boolean {
    return this.isCancellable;
  }

  public getProcesses(): Array<OrderDetailsProcessObject> {
    return this.processes;
  }

  public getFirstProcessId(): string {
    return this.processes.length > 0 ? this.processes[0].getProcessId() : null;
  }

  public isFetched(): boolean {
    return this.orderId !== StringUtils.NOT_AVALIABLE;
  }

}
